// #genai shared footer for all split-layout pages (terms, privacy, copyright)
import React from 'react';
import { makeStyles } from '@eagleview/ev-comp-library';
import { TERMS_OF_USE_LINK, PRIVACY_POLICY_LINK } from '../../constants/AppConstants';

const useStyles = makeStyles(() => ({
  footer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '10px',
    borderTop: '1px solid #C8CDD7',
    background: '#FFF',
    position: 'relative',
    zIndex: 1,
    '@media screen and (max-width: 600px)': {
      flexDirection: 'column',
      border: 'unset',
      gap: '0px',
      padding: '0 0 24px 0',
    },
  },
  section: {
    display: 'flex',
    padding: '10px',
    alignItems: 'center',
    gap: '5px',
    '@media screen and (max-width: 600px)': {
      padding: '10px 24px',
    },
    '& a': {
      color: '#007CAD',
      fontSize: '10px',
      fontFamily: 'Noto Sans, sans-serif',
      fontWeight: 400,
      lineHeight: '12px',
      wordWrap: 'break-word',
    },
  },
  sectionExpand: {
    flex: 1,
  },
  separator: {
    color: '#1B202C',
    fontSize: '10px',
    fontFamily: 'Noto Sans, sans-serif',
    fontWeight: 400,
    lineHeight: '12px',
    wordWrap: 'break-word',
  },
  copyWrite: {
    color: '#4D5365',
    fontSize: '10px',
    fontFamily: 'Noto Sans, sans-serif',
    fontWeight: 400,
    lineHeight: '12px',
    wordWrap: 'break-word',
  },
}));

const SplitLayoutFooter = () => {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={classes.section}>
        <div style={{ textWrap: 'nowrap' }}>
          <a href={TERMS_OF_USE_LINK} style={{ textDecoration: 'none' }}>Terms of use</a>
          <span className={classes.separator}>{' | '}</span>
          <a href={PRIVACY_POLICY_LINK} style={{ textDecoration: 'none' }}>Privacy Policy</a>
        </div>
      </div>
      <div className={`${classes.section} ${classes.sectionExpand}`}>
        <div style={{ flex: '1 1 0', lineHeight: 0.5, overflow: 'hidden' }}>
          <span className={classes.copyWrite}>
            ©
            {(new Date()).getFullYear()}
            {' '}
            EagleView Technologies, Inc. and Pictometry International Corp. All rights reserved.
            {' '}
            Reports issued by EagleView Technologies are covered by one or more international and U.S.
            {' '}
            patents and pending applications, including U.S. Patent Nos. 8,078,436; 8,145,578;
            {' '}
            8,170,840; 8,209,152; 8,515,125; 8,825,454; 9,135,737; 8,670,961; 9,514,568; 8,818,770;
            {' '}
            8,542,880; 9,244,589; 9,329,749; 8,938,090 and 9,183,538. Other patents pending.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default SplitLayoutFooter;
